import styles from './Form.module.css';
import {Zoom} from "react-awesome-reveal";
function Form(props) {
  return (
      <div>
          <div style={{background: '#276A9F', padding: 20}}>
              <center>
                  <div className={styles.headerText}>3 überzeugende Gründe, warum wir Ihr idealer Dienstleister sind</div>
              </center>
          </div>
          <div className={"wrapper"}  style={{padding: 40}}>
              <div className="grid grid-nogutter">
                  <div className={styles.item1 + " lg:col-4 col-12"}>
                      <Zoom triggerOnce>
                      <div className={styles.itemHeader}>
                          <div className={styles.itemNumber}>1</div>
                          Unkompliziert
                      </div>
                      <div className={styles.itemText}>Sie fragen an, wir sind innerhalb von 48 Stunden bei Ihnen vor Ort. Wir bieten Ihnen klare, kompakte Reinigungsdienstleistungen zu fairen Konditionen – ohne Umwege, ohne Bürokratie. Ein persönlicher Ansprechpartner begleitet Sie jederzeit.</div>
                      </Zoom>
                  </div>
                  <div className={styles.item2 + " lg:col-4 col-12"}>
                      <Zoom triggerOnce delay={1000}>
                      <div className={styles.itemHeader}>
                          <div className={styles.itemNumber}>2</div>
                          Qualitativ
                      </div>
                      <div className={styles.itemText}>Ihre Zufriedenheit steht für uns an erster Stelle. Durch regelmäßige interne und externe Qualitätsprüfungen stellen wir sicher, dass unser Service dauerhaft auf einem hohen Niveau bleibt – verlässlich, transparent und messbar.</div>
                      </Zoom>
                  </div>
                  <div className={styles.item1 + " lg:col-4 col-12"}>
                      <Zoom triggerOnce delay={2000}>
                      <div className={styles.itemHeader}>
                          <div className={styles.itemNumber}>3</div>
                          Professionell
                      </div>
                      <div className={styles.itemText}>Unser Team arbeitet sorgfältig, strukturiert und professionell. Ob Reinigungskräfte, Supervisor oder Beschwerdemanagement – Sie werden schnell merken, dass wir in jedem Detail gründlicher sind. Genau das macht den Unterschied.</div>
                      </Zoom>
                  </div>
              </div>
          </div>
      </div>
  );
}

export default Form;
